export default __webpack_public_path__ + "assets/images/RawOTSU-94ffc6fd571ae935feb19781aa8c2277.png";